import React, { useState } from "react";
import { Layout, Menu as AntMenu, Input, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";

import { IMAGE_BASE_URL } from "../../constants/api";
import assets from "../../utils/ImagesPath";
import LS_SERVICE from "../../utils/localStorage";
import { getAPI } from "../../utils/common";
import { APP_PAGE_LIST } from "../../constants/api";
import { DRAWER_MENU } from "../../constants/constent";

const { Sider } = Layout;
const { SubMenu } = AntMenu;

const siderStyle = {
  overflow: "auto",
  height: "95vh",
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: "thin",
  scrollbarGutter: "stable",
};

// Role-wise access control
const USER_ACCESS = {
  superAdmin: "all",
  admin: [
    "dashboard",
    "rate_plan",
    // "external_logs",
    "all_calendar_v2",
    "rooms_view",
    "reservation_data",
    "reservation_add",
    "guests",
    "all_bookings",
    "completed_checkin",
    "completed_multi_booking",
    "pending_checkin",
    "delayed_checkin",
    "upcoming_checkin",
    "upcoming_checkout",
    "delayed_checkout",
    "active_bookings",
    "reservation",
    "orders",
    "contacts",
    "facility",
    "rooms",
    "service",
    "customer",
    "staff",
    "reports",
    "reports_v2",
    "booking_report",
    "night_audit",
    "file-manager",
    "gallery",
    "slider",
    "team",
    "testimonial",
    "product",
    "blog",
    "dynamic-content",
    "profile",
    "laundry_vendor",
    "laundry_item",
    "laundry_stock_adjust",
    "laundry_out",
    "laundry_payment",
    "laundry_report_outstanding",
    "laundry_report_ledger",
    "laundry_report_out",
    "laundry_stock",
    "laundry_stock_ledger",
    "kitchen_item",
    "kitchen_purchase_request",
    "kitchen_purchase",
    "kitchen_purchase_return",
    "kitchen_issue",
    "kitchen_issue_inventory",
    "kitchen_issue_remaining",
    "kitchen_report_stock",
    "kitchen_report_low_stock",
    "kitchen_report_exp_stock",
    "kitchen_report_purchase_request",
    "kitchen_report_purchase",
    "kitchen_report_issue",
    "kitchen_report_daily_stock",
  ],
  reception: [
    "dashboard",
    // "all_calendar",
    "all_calendar_v2",
    "rooms_view",
    "reservation_data",
    "reservation_add",
    "guests",
    "all_bookings",
    "completed_checkin",
    "completed_multi_booking",
    "pending_checkin",
    // "reservation",
    "active_bookings",
    "upcoming_checkin",
    "upcoming_checkout",
    "delayed_checkin",
    "delayed_checkout",
    "orders",
    "contacts",
    // "customer",
    // "pages-seo",
    "profile",
  ],
  laundry: [
    "laundry_vendor",
    "laundry_item",
    "laundry_stock_adjust",
    "laundry_out",
    "laundry_payment",
    "laundry_report_outstanding",
    "laundry_report_ledger",
    "laundry_report_out",
    "laundry_stock",
    "laundry_stock_ledger",
    "profile",
  ],
  kitchen: ["orders", "profile"],
  kitchen_store_manager: [
    "kitchen_item",
    "kitchen_purchase_request",
    "kitchen_purchase",
    "kitchen_purchase_return",
    "kitchen_issue",
    "kitchen_issue_inventory",
    "kitchen_issue_remaining",
    "kitchen_report_stock",
    "kitchen_report_low_stock",
    "kitchen_report_exp_stock",
    "kitchen_report_purchase_request",
    "kitchen_report_purchase",
    "kitchen_report_issue",
    "kitchen_report_daily_stock",
    "profile",
  ],
  kitchen_stock_manager: [
    "kitchen_issue_inventory",
    "kitchen_issue_remaining",
    "kitchen_report_issue",
    "profile",
  ],
  biller: [
    "dashboard",
    "all_bookings",
    "active_bookings",
    "delayed_checkout",
    "orders",
    "reports",
    "reports_v2",
    "booking_report",
    "night_audit",
    "profile",
  ],
  accountant: [
    "reservation_add",
    "guests",
    "all_bookings",
    "profile",
    "laundry_payment",
    "laundry_report_outstanding",
    "laundry_report_ledger",
    "laundry_report_out",
    "laundry_stock",
    "laundry_stock_ledger",
  ],
  webAdmin: [
    "pages-seo",
    "orders",
    "file-manager",
    "gallery",
    "slider",
    "team",
    "testimonial",
    "category",
    "product",
    "blog",
    "profile",
  ],
};

const menuCategories = DRAWER_MENU;

function Drawer() {
  const [collapsed, setCollapsed] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [appPages, setAppPages] = useState([]);

  const userType = LS_SERVICE.get("user_type");
  const allowedKeys =
    USER_ACCESS[userType] === "all" ? "all" : USER_ACCESS[userType] || [];

  const { logo, favicon } = LS_SERVICE.get("setting") || {};
  const logoSrc = logo
    ? `${IMAGE_BASE_URL}${collapsed ? favicon : logo}`
    : assets.logo;

  const filteredMenuCategories = menuCategories
    .map(({ category, icon, items }) => ({
      category,
      icon,
      items: items.filter((item) => {
        const matchesSearch = item.label
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
        const hasAccess =
          allowedKeys === "all" || allowedKeys.includes(item.key);
        return matchesSearch && hasAccess;
      }),
    }))
    .filter(({ items }) => items.length > 0);

  React.useEffect(() => {
    getAPI(
      APP_PAGE_LIST,
      (res) => {
        if (res.status === true) {
          setAppPages(res.data);
        }
      },
      () => {},
    );
  }, []);

  const isRouteEnabled = (route) => {
    const page = appPages.find((p) => p.route === route);
    return page ? page.is_enabled : true; // default allow
  };

  return (
    <Sider
      width={320}
      style={siderStyle}
      theme="light"
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      <div style={{ padding: "10px" }}>
        <img className="logo" src={logoSrc} alt="Logo" />
        <br />
        <Input
          placeholder="Search menu"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <AntMenu
        theme="light"
        mode="inline"
        defaultSelectedKeys={["dashboard"]}
        defaultOpenKeys={["Dashboard"]}
        // defaultOpenKeys={filteredMenuCategories.map((cat) => cat.category)}
      >
        {filteredMenuCategories.map(({ category, icon, items }) => (
          <SubMenu key={category} title={category} icon={icon}>
            {items.map(({ key, icon, label, to }) => {
              const enabled = isRouteEnabled(to);

              return (
                <AntMenu.Item
                  key={key}
                  icon={
                    enabled ? icon : <LockOutlined style={{ color: "red" }} />
                  }
                  disabled={!enabled}
                >
                  {enabled ? (
                    <Link to={to}>{label}</Link>
                  ) : (
                    <Tooltip title="This page is disabled by admin">
                      <span style={{ color: "#999" }}>{label}</span>
                    </Tooltip>
                  )}
                </AntMenu.Item>
              );
            })}
          </SubMenu>
        ))}
      </AntMenu>
    </Sider>
  );
}

export default Drawer;
